// Copyright (c) Bentley Systems
import { ToastNotificationText } from "./toast-notification-text";

export class ToastNotification {
  public toastNotificationTexts: ToastNotificationText[];
  constructor(initializer: any) {
    this.toastNotificationTexts = initializer.toastNotificationTexts;
  }
}
